<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{ title }}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
    </h1>
    <div class="scroll" fxFlex.gt-sm="auto" fxLayout="column" fxLayoutAlign="start stretch">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-form-field appearance="outline">
            <textarea matInput [(ngModel)]="note" aria-label="Text entry space" [placeholder]="placeholderText"></textarea>
        </mat-form-field>
        <div>
            The original priority specified for this request is displayed below. If you wish, you may change the priority of this
            request at this time by selecting a different priority from the list of available priority levels. (Note: A revised due
            date for the request will be established when this time approval is marked in the system.)
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <mat-form-field appearance="outline" fxFlex="35">
                <mat-select matInput [ngModel]="priority" (ngModelChange)="UpdatePriority($event)" aria-label="Request priority level">
                    <mat-option [value]="1">1 - Urgent</mat-option>
                    <mat-option [value]="2">2 - High</mat-option>
                    <mat-option [value]="3">3 - Routine</mat-option>
                    <mat-option [value]="4">4 - Low</mat-option>
                </mat-select>
                <mat-hint *ngIf="priority && priority !== 4">
                    <em>Suggested for requests needed within {{ priority | priorityTime }}</em>
                </mat-hint>
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex fxFlex.lt-md="auto">
                <app-form-label [required]="true">Due Date:</app-form-label>
                <mat-form-field appearance="outline" *ngIf="priority === 4">
                    <input
                        type="text"
                        [(ngModel)]="duedate"
                        matInput
                        aria-label="Request Due Date"
                        [matDatepicker]="dueDatePicker"
                        [matDatepickerFilter]="IsValidWorkday.bind(this)"
                        placeholder="Select due date..."
                    />
                    <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dueDatePicker></mat-datepicker>
                    <!-- <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('matDatepickerFilter')">Monday to Friday only</mat-error>
                                <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('required')">Required.</mat-error> -->
                </mat-form-field>
                <div *ngIf="priority !== 4 && duedate">{{ duedate | date: 'M/d/yyyy' }}</div>
            </div>
        </div>
    </div>
    <div
        class="actionbar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <button mat-raised-button color="warn" (click)="CancelHandler()">{{ canceltext }}</button>
        <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="noterequired && !note">{{ oktext }}</button>
    </div>
</div>
